module.exports = __webpack_public_path__ + "static/diglotreaders-5ebb8173cb0e41932c01b03040e2d9e6.jpg";